import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../components/SEO';
import Layout from '../layouts/index';
import ReactPlayer from 'react-player';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import HtmlParser from 'html-react-parser';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';
import JoinHappyCustomers from '../components/JoinHappyCustomers';
import { Link } from 'react-scroll'
import { DemoFormShort } from '../components/DemoFormShort.jsx';
import { DemoFormLong } from '../components/DemoFormLong.jsx';
import MultimedialPanel from '../components/MultimedialPanel';
import FeaturedPress from '../components/FeaturedPress.js';
import Testimonials from  '../components/Testimonials.js';
import { PATHS } from '../utils/urls';

function HeroModal() {
	const [modalShow, setModalShow] = React.useState(false);

	const handleModalClose = () => setModalShow(false);
	const handleModalShow = () => setModalShow(true);

	return (
		<div className="d-flex mt-1 mb-1">
			<Button variant="" onClick={handleModalShow} className="cta cta-video">Watch short video</Button>

			<Modal show={modalShow} onHide={handleModalClose} centered>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>
					<ResponsiveEmbed aspectRatio="16by9">
						<ReactPlayer
							url='https://charthop.wistia.com/medias/msgs17xs45'
							playing
							volume={1}
							controls={false}
							width='100%'
							height='100%'
						/>
					</ResponsiveEmbed>

				</Modal.Body>
			</Modal>
		</div>
	);
}


const Home = (props) => {
	const location = props.location;

	return (
		<Layout bodyClass="page-home-index2" ontouchstart>
			<SEO title="ChartHop | The Org Management Platform" />
			<Helmet>
				<meta name="description" content="Automatically create and update org charts, build headcount plans and analyze all your people data in one central hub, no spreadsheets needed."/>
				<meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
				<meta property="og:title" content="ChartHop | The Org Management Platform" />
				<meta property="og:description" content="Automatically create and update org charts, build headcount plans and analyze all your people data in one central hub, no spreadsheets needed." />
				<meta property="og:image" content={`https://www.charthop.com/home/meta-home.gif`} />
				<meta property="og:type" content="website" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:site_name" content="ChartHop" />
				{/* Twitter Card tags */}
				<meta name="twitter:title" content="ChartHop | The Org Management Platform" />
				<meta name="twitter:description" content="Automatically create and update org charts, build headcount plans and analyze all your people data in one central hub, no spreadsheets needed." />
				<meta name="twitter:image" content={`https://www.charthop.com/home/meta-home.gif`} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@charthop" />
				<meta name="twitter:creator" content="@charthop" />

			</Helmet>
			<section className="intro container">
				<div className="row align-items-center">
					<div className="col-md-6 p-xs-2 mb-3 mb-md-0 pr-md-2 pr-lg-4">
						<h1>The strategic platform for people leaders.</h1>	
						<div>
							<DemoFormShort source={"home-page-demo-header"} />
							<HeroModal />
						</div>
					</div>
					<div className="reactPlayerContainer col-md-6 col-lg-6 order-md-1" >
						<ReactPlayer
							url="/home/Hero_index2.mp4"
							playing
							loop
							muted
							playsinline
						/>
					</div>
				</div>
			</section>

			{/* COSTUMERS */}
			<section className="customer testimonial-container pt-8 pb-5 ">
				<JoinHappyCustomers title={HtmlParser('Join our <span class="blue-text">hoppy</span> customers')}></JoinHappyCustomers>
			</section >	
			
			{/* THE SOLUTION */}
			<section className="the-solution">
				<div className="container pt-3 pt-md-5 pb-5  ">

					{/* ANCHORS */}
					<div className="row align-items-center mb-2 mb-md-5 mb-lg-5">
						<div className="col-md-12 text-center">
							<div className="d-flex justify-content-between justify-content-sm-center">
								<Link to="Centralize" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Centralize</Link>
								<Link to="Visualize" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Visualize</Link>
								<Link to="Optimize" smooth={true} offset={-70} duration={500} className="inline-anchor smoothScrollLink">Optimize</Link>
							</div>
						</div>
					</div>

					{/* CENTRALIZE */}
					<div name="Centralize" id="Centralize" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="left"
							title="CENTRALIZE"
							link="/product/people-analytics/Integration_reports-2.mp4"
							type="video"
							paddingClass="padding-top-video-1"
							content={
								<React.Fragment>
									<h2>Centralize your people data with seamless integrations</h2>
									<p>Give your team the context they need to do their jobs faster and better.</p>
									<p>Provide a single point of access for current and historical data to create data-informed strategy, without any manual work or human error.</p>
									<p className="mb-0"><a href={PATHS.INTEGRATIONS} className="ctaStandard"> Learn more</a></p>
								</React.Fragment>
							}
						/>
					</div>

					{/* VISUALIZE */}
					<div name="Visualize" id="Visualize" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="right"
							title="VISUALIZE"
							link="/home/Visualize_index2.mp4"
							type="video"
							paddingClass="padding-top-video-2"
							content={
								<React.Fragment>
									<h2>Visualize your people data and finally see the full picture</h2>
									<p>Analyze everything from headcount by department to average compensation by gender to turnover by performance rating. </p>
									<p>Leverage powerful visualizations including first-of-its-kind org chart reporting, maps for remote teams and robust, customizable reports.</p>
									<p>Data is power - and visualizing it is now your catalyst for change.</p>
								</React.Fragment>
							}
						/>
					</div>

					{/* OPTIMIZE */}
					<div name="Optimize" id="Optimize" className="contentBlock">
						<MultimedialPanel 
							multimediaPosition="left"
							title="OPTIMIZE"
							link="/home/optimized-index2.mp4"
							type="video"
							paddingClass="padding-top-video-3"
							content={
								<React.Fragment>
									<h2>Optimize your team with data-driven, strategic planning</h2>
									<p>Build the agile and adaptable organization the changing market demands.
									</p> 
									<p> Keep People, Finance, Recruiting and people managers aligned with one view of the future of your organization.</p>
									<p>Now, everyone plans off the same platform and has the full context as they propose and review raises, promotions, org restructures, hiring plans and more. No spreadsheets required.</p>
								</React.Fragment>
							}
						/>
					</div>

				</div>
			</section>

			{/* AS FEATURED IN */}

			<FeaturedPress bgGrey backgroundGradientContainer />

			{/* YOUR FOCUS */}
			<section >
				<div className="container pt-3 pb-3 pt-md-6 pb-md-6">
					<div className="row align-items-center">

						<div className="col-md-8 col-lg-6 offset-lg-1 ">
							<h2 className="mb-2">You focus on your people. We'll focus on keeping your data safe.</h2>
							<p>You're entrusting ChartHop with your most valuable data, and we take this responsibility very seriously.</p>
							<div className="text-center d-block d-md-none d-block mr-auto ml-auto mt-4 mb-4">
								{/* <LazyLoad height={250} offset={100}  once={true}> */}
								<img src='/home/safety.svg' alt="Safety" className="" width="195" />
								{/* </LazyLoad> */}
							</div>
							<div className="container d-sm-flex">
								<ul className="col-md-6 pb-0 pr-3">
									<li>Complete SOC 2 Type 2 Examination</li>
									<li>Encryption at rest & in transit</li>
									<li>Biometric and physical-key two-factor access control</li>
								</ul>

								<ul className="col-md-6 pt-0 pr-3">
									<li>Mandatory SSO enforcement</li>
									<li>Employee auto-offboarding</li>
									<li>Customizable permission controls</li>
								</ul>


							</div>

						</div>

						<div className="reactPlayerContainer col-md-4 col-lg-3 offset-lg-1" >
							<img src='/home/safety.svg' alt="Safety" className="p-2 d-none d-md-block " />
						</div>
					</div>
				</div>
			</section>

			<Testimonials bgGrey />

			{/* REQUEST DEMO */}
			<section name="request-demo" id="request-demo" className="request-demo sectionSpacing">
				<DemoFormLong source={"home-page-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial-index2">"Planning and managing organizations, people growth and modeling org changes has been mostly manual until now - ChartHop makes it all happen in software."</p><div class="authorTag"><img src="/supporters/aileen-cowboy.png" class="testimonialAuthor" alt="Aileen Lee from Cowboy" /><div><p class="contactAuthor"><strong>Aileen Lee</strong> <br>Founder & Partner, Cowboy Ventures</p></div></div>')}/>
			</section>
		</Layout>
	);
};


export default Home;